/* Yips polish: paginate the Judge.me "all reviews" list (collection pages) —
   show 5 at a time with a "Load more" button. Nothing is deleted; every review
   stays in the page and is revealed on click. */
(function () {
  var STEP = 5;
  function setup(list) {
    if (list.__yipsPaged) return;
    list.__yipsPaged = true;
    var shown = STEP;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'jdgm-btn jdgm-btn--solid yips-rev-more';
    btn.addEventListener('click', function () { shown += STEP; apply(); });
    list.parentNode.insertBefore(btn, list.nextSibling);
    function apply() {
      var revs = list.querySelectorAll(':scope > .jdgm-rev');
      for (var i = 0; i < revs.length; i++) revs[i].classList.toggle('yips-rev-later', i >= shown);
      var left = revs.length - shown;
      btn.hidden = left <= 0;
      btn.textContent = 'Load more reviews (' + Math.max(left, 0) + ')';
    }
    apply();
    new MutationObserver(function () { shown = STEP; apply(); }).observe(list, { childList: true });
  }
  function scan() {
    document.querySelectorAll('.jdgm-all-reviews-widget .jdgm-all-reviews__body').forEach(setup);
  }
  var tries = 0;
  var t = setInterval(function () { scan(); if (++tries > 40) clearInterval(t); }, 500);
  document.addEventListener('DOMContentLoaded', scan);
})();
